var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-progress-btn"},[_c('div',{staticClass:"progress-text-box"},[_c('span',{staticClass:"progress-text"},[_vm._v("0%")]),_c('p',{staticClass:"top-text-normal"},[_vm._v("置顶")])]),_c('span',{staticClass:"top-text"},[_c('i',{staticClass:"el-icon-top",staticStyle:{"margin":"0"}}),_vm._v("置顶")])])
}]

export { render, staticRenderFns }